import * as PropTypes from 'prop-types';
import cx from 'classnames';
import { Switch } from '@headlessui/react';

const SwitchButton = ({ className, onClick, enabled, labelOn, labelOff }) => {
    return (
        <Switch
            checked={enabled}
            onChange={onClick}
            className={cx(className, 'w-full')}
            tabIndex='-1'
        >
            <div className='relative flex h-11 w-full rounded-xxl bg-switch-button p-1'>
                <span
                    className={cx(
                        'z-0 block h-full w-1/2 transform rounded-xxl bg-switch-button-toggle transition duration-300 ease-in-out',
                        [`${enabled && 'translate-x-full'}`]
                    )}
                ></span>
                <div className='absolute inset-0 flex h-full w-full items-center justify-center'>
                    <span
                        className={cx('w-1/2 font-body', [
                            `${
                                enabled
                                    ? 'font-body-regular text-ui-black'
                                    : 'font-body-normal text-ui-white'
                            }`,
                        ])}
                    >
                        {labelOn}
                    </span>
                    <span
                        className={cx('w-1/2 font-body', [
                            `${
                                enabled
                                    ? 'font-body-normal text-ui-white'
                                    : 'font-body-regular text-ui-black'
                            }`,
                        ])}
                    >
                        {labelOff}
                    </span>
                </div>
            </div>
        </Switch>
    );
};

SwitchButton.propTypes = {
    className: PropTypes.string,
    enabled: PropTypes.bool,
    onClick: PropTypes.func,
};

export default SwitchButton;
